import React, { useEffect, useState } from 'react';


const InstallBanner = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isHover, setIsHover] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
      setTimeout(() => setShowBanner(false), 5000);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setShowBanner(false);
      }
      setDeferredPrompt(null);
    }
  };



  const bannerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '60px',
    background: '#4F46E5',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    zIndex: 9999,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    animation: 'fadeInTop 0.5s',
  };

  const buttonStyle = {
    background: '#fff',
    color: '#4F46E5',
    border: 'none',
    padding: '10px 28px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '1rem',
    transition: 'background 0.2s, color 0.2s',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  };


  // Add keyframes for fadeInTop animation
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `@keyframes fadeInTop { from { opacity: 0; transform: translateY(-30px); } to { opacity: 1; transform: translateY(0); } }`;
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  const hoverStyle = isHover
    ? { background: '#e0e7ff', color: '#3730a3' }
    : {};

  if (!showBanner) return null;

  return (
    <div style={bannerStyle}>
      <span>Install App for a better experience!</span>
      <button
        style={{ ...buttonStyle, ...hoverStyle }}
        onClick={handleInstallClick}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        Install App
      </button>
    </div>
  );
};

export default InstallBanner;
